/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/home",
    name: "Campaña Operaciones",
    slug: "home",
    icon: "ActivityIcon",
  },
 /*  {
    url: "/judicial",
    name: "Campaña Judicial",
    slug: "judicial",
    icon: "TrelloIcon",
  }, */
  /* {
    url: '/videocall',
    name: "Videocall",
    slug: "Videocall",
    icon: "TrelloIcon"
  }, */
  {
    url: '/contactList',
    name: "Contact List",
    slug: "Contact List",
    icon: "ListIcon"
  },
  {
    url: '/addContact',
    name: "Add Contact",
    slug: "Add Contact",
    icon: "TrelloIcon"
  }
]
